<template>
  <div>
    <v-menu
      v-model="filterMenu"
      :close-on-content-click="false"
      width="360"
      max-width="360"
      z-index="999"
    >
      <template v-slot:activator="{ on, attrs }">
        <div>
          <span class="text-caption">{{ shownDate }}</span>
          <v-icon
            v-bind="attrs"
            v-on="on"
            right
            color="accent"
          >
            mdi-calendar
          </v-icon>
        </div>
      </template>
      <v-list>
        <v-list-item data-testid="date-filter-specific-date" class="mt-3">
          <v-menu
            ref="menu"
            v-model="startDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                color="accent"
                v-model="startDateSelected"
                v-bind="attrs"
                v-on="on"
                readonly
                clearable
                data-testid="date-input"
                class="mr-3 pa-0 set-date-filter"
                max-width="100px"
                :rules="dateRules"
              >
                <template v-slot:prepend-inner>
                  <v-icon color="accent">mdi-calendar</v-icon>
                </template>
                <template v-slot:label>
                  <div>
                    <span
                      class="text-subtitle-2 accent--text"
                      >{{ $t("startDate") }}</span
                    >
                  </div>
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="startDateSelected" no-title @input="startDateMenu = false">
            </v-date-picker>
          </v-menu>
          <v-menu
            ref="menu"
            v-model="endDateMenu"
            :close-on-content-click="false"
            :nudge-left="140"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                color="accent"
                v-model="endDateSelected"
                v-bind="attrs"
                v-on="on"
                readonly
                clearable
                data-testid="date-input"
                class="pa-0 set-date-filter"
                max-width="100px"
                :rules="dateRules"
              >
                <template v-slot:prepend-inner>
                  <v-icon color="accent">mdi-calendar</v-icon>
                </template>
                <template v-slot:label>
                  <div>
                    <span
                      class="text-subtitle-2 accent--text"
                      >{{ $t("endDate") }}</span
                    >
                  </div>
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="endDateSelected" no-title @input="endDateMenu = false">
            </v-date-picker>
          </v-menu>
          <v-icon @click="setSpecificDate" color="accent" data-testid="date-filter-specific-date-apply">mdi-chevron-right</v-icon>
        </v-list-item>
        <v-list-item data-testid="date-filter-this-month" @click="setDate(0), shownDate = $t('filterThisMonth')">
          <v-list-item-title>{{ $t('filterThisMonth') }}</v-list-item-title>
        </v-list-item>
        <v-list-item data-testid="date-filter-last-3-months" @click="setDate(3), shownDate = $t('filterLastThreeMonths')">
          <v-list-item-title>{{ $t('filterLastThreeMonths') }}</v-list-item-title>
        </v-list-item>
        <v-list-item data-testid="date-filter-last-6-months" @click="setDate(6), shownDate = $t('filterLastSixMonths')">
          <v-list-item-title>{{ $t('filterLastSixMonths') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import { ruleRequired } from '../rules/formRules.js';
import moment from 'moment'

export default {
    mixins: [repeatedMethodsMixin],
     props: {
  },
  data: function() {
    return { 
      startDateSelected: moment().startOf('year').format('YYYY-MM-DD'),
      endDateSelected: moment().format('YYYY-MM-DD'),
      startDateMenu: false,
      endDateMenu: false,
      filterMenu: false,
      shownDate: '',
      dateRules: ruleRequired('labelDate'),
    }
  },
  created(){
    this.setSpecificDate()
  },
  methods: {
    setDate(months){
      this.filterMenu = false

      if(months == 0){
        this.startDateSelected = new Date()
        this.startDateSelected = moment(new Date(this.startDateSelected.getFullYear(), this.startDateSelected.getMonth(), 1)).format('YYYY-MM-DD')
      }else {
        this.startDateSelected = new Date()
        this.startDateSelected = moment(this.startDateSelected.setMonth(this.startDateSelected.getMonth() - months)).format('YYYY-MM-DD')
      }

      this.endDateSelected = moment().format("YYYY-MM-DD")
      
      this.$emit('dateFilter', this.startDateSelected, this.endDateSelected)
    },
    setSpecificDate(){
      if(this.startDateSelected !== null && this.endDateSelected !== null && this.startDateSelected <= this.endDateSelected){
        this.filterMenu = false
        this.shownDate = this.startDateSelected + ' - ' + this.endDateSelected
        this.$emit('dateFilter', this.startDateSelected, this.endDateSelected)
      } 
    },
  },
}
 
</script>